export default __webpack_public_path__ + "static/media/B175.0ec282fa.png";